// component/modal/taxonomy
import { memo } from 'react';
import ApproachLocale from 'locale/en/approach.json';

const ModalTaxonomy = () => {
  const dataLG = [
    [
      ['Bifidobacterium'],
      ['adolescentis', 'breve', 'infantis', 'lactis', 'longum'],
      ['SD-BA5-IT', 'SD-BR3-IT', 'SD-M63-JP', 'SD-CECT8145-SP', 'SD-BB536-JP'],
      ['', 'HRVD521-US', '', 'SD-BS5-IT', 'HRVD90b-US'],
      ['', '', '', 'SD-MB2409-IT', 'SD-CECT7347-SP'],
      ['', '', '', 'HRVD524-US', ''],
      ['', '', '', 'SD-150-BE', ''],
    ],
    [
      ['Lacticaseibacillus', 'Limosilactobacillus'],
      ['casei', 'rhamnosus', 'fermentum', 'reuteri'],
      ['SD-CECT9104-SP', 'HRVD113-US', 'SD-LF8-IT', 'SD-LRE2-IT'],
      ['HRVD300-US', 'SD-LR6-IT', '', 'SD-RD830-FR'],
      ['', 'SD-GG-BE', '', ''],
    ],
    [
      ['Lactiplantibacillus', 'Ligilactobacillus', 'Lactobacillus'],
      ['plantarum', 'salivarius', 'crispatus'],
      ['SD-LP1-IT', 'SD-LS1-IT', 'SD-LCR01-IT'],
      ['SD-LPLDL-UK', '', '', ''],
    ],
  ];
  const dataSM = [
    [
      ['Bifidobacterium'],
      ['adolescentis', 'SD-BA5-IT'],
      ['breve', 'SD-BR3-IT', 'HRVD521-US'],
      ['infantis', 'SD-M63-JP'],
      [
        'lactis',
        'SD-CECT8145-SP',
        'SD-BS5-IT',
        'SD-MB2409-IT',
        'HRVD524-US',
        'SD-150-BE',
      ],
      ['longum', 'SD-BB536-JP', 'HRVD90b-US', 'SD-CECT7347-SP'],
    ],
    [
      ['Lacticaseibacillus'],
      ['casei', 'SD-CECT9104-SP', 'HRVD300-US'],
      ['rhamnosus', 'HRVD113-US', 'SD-LR6-IT', 'SD-GG-BE'],
    ],
    [
      ['Limosilactobacillus'],
      ['fermentum', 'SD-LF8-IT'],
      ['reuteri', 'SD-LRE2-IT', 'SD-RD830-FR'],
    ],
    [['Lactiplantibacillus'], ['plantarum', 'SD-LP1-IT', 'SD-LPLDL-UK']],
    [['Ligilactobacillus'], ['salivarius', 'SD-LS1-IT']],
    [['Lactobacillus'], ['crispatus', 'SD-LCR01-IT']],
  ];
  return (
    <>
      <div className='head'>
        <p>{ApproachLocale.approach}</p>
        <span>{ApproachLocale.strain_taxonomy}</span>
      </div>
      <div className='legend'>
        <div className='title'>{ApproachLocale.ds_01_daily_synbiotic}</div>
        <ul className='list'>
          <li>
            <i />
            Genus
          </li>
          <li>
            <i />
            Species
          </li>
          <li>
            <i />
            Strain
          </li>
        </ul>
      </div>
      <div className='taxtable'>
        <div className='container'>
          <div className='db dn-ns'>
            {dataSM.map((a, ai) => (
              <div className={`a a${ai}`} key={`a${ai}`}>
                {a.map((b, bi) => (
                  <div className={`b b${bi}`} key={`b${bi}`}>
                    {b.map((c, ci) => (
                      <div className={`c c${ci}`} key={`c${ci}`}>
                        <span>{c}</span>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            ))}
          </div>
          <div className='dn db-ns'>
            {dataLG.map((a, ai) => (
              <div className={`a a${ai}`} key={`a${ai}`}>
                {a.map((b, bi) => (
                  <div className={`b b${bi}`} key={`b${bi}`}>
                    {b.map((c, ci) => (
                      <div className={`c c${ci}`} key={`c${ci}`}>
                        <span>{c}</span>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default memo(ModalTaxonomy);
